import AddressBooks from "@/views/Home/ktpMessage/addressBooks.vue";
import Chat from "@/views/Home/ktpMessage/chat.vue";
import ChatHistory from "@/views/Home/ktpMessage/chatHistory.vue";
import SchoolMsg from "@/views/Home/Message/SchoolMsg.vue";
import i18n from "@/lang";
export default [
  {
    name: i18n.t('message.通讯录') as string,
    path: '/addressBooks',
    component: AddressBooks,
  },
  {
    name: "chat",
    path: '/chat',
    component: Chat,
  },
  {
    name: i18n.t('message.查看旧版聊天记录') as string,
    path: '/ChatHistory',
    component: ChatHistory,
  },
  {
    name: i18n.t('message.通知') as string,
    path: '/schoolmsg',
    component: SchoolMsg,
  },
]
